import {Platform} from 'react-native';

import {useFeatureFlags} from '@components/_context';
import {ConfigurationApplication} from '@application/Config';
import {TradeName} from '@domain/model/Config/Configuration';

const platform: string = Platform.OS;

const FEATURE_FLAGS: Record<string, string[]> = {
  android: ['DISABLE_GOOGLE_SIGN_IN_ANDROID_OF', 'DISABLE_FACE_BOOK_SIGN_IN_ANDROID_OF'],
  web: ['DISABLE_GOOGLE_SIGN_IN_WEB_OF', 'DISABLE_FACE_BOOK_SIGN_IN_WEB_OF'],
  ios: ['DISABLE_GOOGLE_SIGN_IN_IOS_OF', 'DISABLE_FACE_BOOK_SIGN_IN_IOS_OF'],
};

const {tradename} = ConfigurationApplication.retrieve();
const [googleSignInFlag, faceBookSigInFlag] = FEATURE_FLAGS[platform] || [];

export const useShowSocialLogins = (): {showFacebookSignInOF: boolean; showGoogleSignInOF: boolean} => {
  const featureFlags = useFeatureFlags();

  return {
    showFacebookSignInOF:
      tradename === TradeName.OUTFITTERY && (!faceBookSigInFlag || !featureFlags[faceBookSigInFlag]),
    showGoogleSignInOF: tradename === TradeName.OUTFITTERY && (!googleSignInFlag || !featureFlags[googleSignInFlag]),
  };
};
